import * as amplitude from '@amplitude/analytics-browser';
import { hasProperty } from '@squaredup/utilities';

// Fail closed: stays true until identifyUser confirms a non-synthetic tenant.
let isSyntheticTenant = true;

export const getIsSyntheticTenant = () => isSyntheticTenant;
export const setIsSyntheticTenant = (value: boolean) => {
    isSyntheticTenant = value;
};

// Best-effort: runs immediately before the MSAL logout redirect, so a throw would strand the user.
export const resetTelemetry = () => {
    isSyntheticTenant = true;

    try {
        if (hasProperty(window, 'analytics') && typeof window.analytics === 'object' && window.analytics != null) {
            window.analytics.reset();
        }
    } catch {
        /* empty */
    }

    try {
        if (window.customerIO) {
            window.customerIO.reset();
        }
    } catch {
        /* empty */
    }

    try {
        amplitude.reset();
    } catch {
        /* empty */
    }
};
